import { FunctionComponent, memo } from "react";
import RoleSummary from "../role-summary";

import { IProps } from "./role-list.types";
import "./role-list.scss";

/**
 * Display all roles
 * @param props.roles       Array of roles available in database
 */
const RoleList: FunctionComponent<IProps> = ({ roles }) => (
    <>
        {roles.map((role) => (
            <th key={role.roleId}>
                <RoleSummary role={role} />
            </th>
        ))}
    </>
);

export default memo(RoleList);
